import React, {createContext, KeyboardEventHandler, ReactNode, useContext, useEffect, useState} from 'react';
import ZooPassStepDataUtility from "../../Utilities/ZooPassStepDataUtility";
import {useZooPassAppContext} from "../../Context/ZooPassAppContext";
import {MembershipDto} from "../../Data/TnewMemberDetails";
import classNames from 'classnames';


export interface RenewalAnswerCardProperties {
    onSelect?: () => void;
    detail: MembershipDto;
}

export const RenewalAnswerCard: React.FC<RenewalAnswerCardProperties> = ({onSelect, detail}) => {

    let {
        dictionary,
        zooPassMembership,
        loading
    } = useZooPassAppContext();
    
    const [expiresText, setExpiresText] = useState<string>();
    
    //////////////////////////////////////////////////////////////////////////////////////
    // Renew Date / Text

    const [rawRenewDate, setRawRenewDate] = useState<Date | null | undefined>();
    const [renewDate, setRenewDate] = useState<Date>(new Date());
    const [renewText, setRenewText] = useState<string | null>();
    const [disabled, setDisabled] = useState<boolean>(false);
    
    const actionStatusActionable = "actionable";
    const actionStatusPending = "pending";
    const actionStatusRenewable = "renewable";
    
    
    useEffect(() => {
        if(!loading) { 
            setRenewDate(rawRenewDate ?? new Date());
            if(rawRenewDate != null) {
                let rawRenew = dictionary.get("ZooPass:StepLayout:02:Renew:RenewedFrom") ?? "";
                setRenewText(rawRenew.replace("%s",
                    rawRenewDate?.toLocaleString('en-US', {year:'numeric', month: 'long', day:'numeric'})
                ));
            }else{
                setRenewText(null);
            }
        }
    }, [rawRenewDate, loading, dictionary]);
    
    useEffect(() => {
        if(!loading) {
            setDisabled(detail.actionStatus == actionStatusPending || detail.actionStatus == actionStatusRenewable);
        }
    }, [renewDate, loading]);
    
    // END: Renew Date / Text
    //////////////////////////////////////////////////////////////////////////////////////
    
    useEffect(() => {
        if(!loading){
            let rawExpires = dictionary.get("ZooPass:StepLayout:02:Renew:Expires");
            if(rawExpires !== undefined) {
                setExpiresText(rawExpires.replace("%s", 
                    ZooPassStepDataUtility.GetDateFromIso8601(detail.expirationDate)?.toLocaleString('en-US', {year:'numeric', month: 'long', day:'numeric'}) ?? ""
                ));
            }
            setRawRenewDate(ZooPassStepDataUtility.GetDateFromIso8601(detail.renewalDate));
        }
    },[loading, dictionary]);
    
    const handleKeyUpListen = (event : React.KeyboardEvent<HTMLLabelElement>) => {
        if(!event.altKey && !event.metaKey && !event.shiftKey && !disabled) {
            if(event.key === 'Enter' || event.key === 'Space') {
                console.log("Key press");
                event.stopPropagation();
                if(onSelect) onSelect();
                return;
            }
        }
    };
    
    const handleClickListen = () => {
        if(disabled) return;
        console.log("Click");
        if(onSelect) onSelect();
    }
    
    return !loading && dictionary != null && (<>
        <div className="radio-wrapper radio-wrapper--column">
            <div className="membership-item">
                <div className={classNames('radio','radio--wrapped',{'radio--disabled':disabled})}>
                    <label tabIndex={0} className="radio__label"
                           onKeyUpCapture={ (event) => handleKeyUpListen(event)} 
                           onClick={() => handleClickListen()}>
                        <input type="radio" name="gift" disabled={disabled} style={{display: "none"}} tabIndex={-1}/>
                        <div className="radio__label-content">
                            <h6 className="mb-1 membership-heading">{zooPassMembership.get(detail.membershipLevel.code)?.title ?? detail.membershipLevel.description}</h6>
                            <p className="mb-1">{detail.constituent.displayName}</p>
                            <p className="text--muted mb-1">{expiresText}</p>
                            {disabled && detail.actionStatus == actionStatusRenewable && <p className="membership-item__renewal-date">{renewText}</p>}
                            {disabled && detail.actionStatus == actionStatusPending && <p className="membership-item__renewal-date">{dictionary.get("ZooPass:StepLayout:02:Renew:Pending")}</p>}
                        </div>
                    </label>
                </div>
            </div>
        </div>
    </>);
}